* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  padding: calc(var(--spacer) * 2) 0 0 var(--spacer);
  display: flex;
  height: auto;
  width: auto;
  flex-wrap: wrap;
}

#actionCategoryName {
  display: none;

  &.show-chategory {
    display: flex;
  }

  height: auto;
  width: 100%;
  color: var(--chart-300-icon-buttons);
  font-size: var(--body-size-small);
  font-weight: 600;
  padding: var(--spacer) 0 var(--spacer) 0;
  text-transform: uppercase;
}

#actions {
  width: 100%;

  .action-container {
    display: flex;
    align-items: center;
    padding: 4px 0 4px 0;

    &:not(:last-child) {
      border-bottom: 1px solid var(--chart-100-pressed);
    }

    gz-link {
      overflow: hidden;
      margin-right: calc(var(--spacer) * 2);
      width: calc(var(--spacer) * 4);
      text-overflow: ellipsis;
    }

    gz-link::part(container) {
      color: var(--body-text-arrows-400);

      &:hover {
        color: var(--blue-layout-400-primary);
      }
    }

    gz-title {
      display: inline-block;
      width: inherit;
    }
  }
}

#detailsLink {
  text-transform: uppercase;
  font-weight: 500;
  line-height: 11px;
  padding: var(--spacer) 0;
}
